module.exports = __webpack_public_path__ + "img/ears_female_mask.723c17e8.png";